import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as EquipmentActions from '../_actions/equipment';
import { Equipment } from '../_models';

export interface EquipmentState extends EntityState<Equipment> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Equipment> = createEntityAdapter<Equipment>();

const initialState: EquipmentState = adapter.getInitialState({
  loading: false,
  error: null,
});

const equipmentReducer = createReducer(
  initialState,

  on(EquipmentActions.loadEquipments, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EquipmentActions.loadEquipmentsSuccess, (state, { equipments }) =>
    adapter.setAll(equipments, { ...state, loading: false })
  ),

  on(EquipmentActions.loadEquipmentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EquipmentActions.addEquipmentSuccess, (state, { equipment }) =>
    adapter.addOne(equipment, state)
  ),

  on(EquipmentActions.updateEquipmentSuccess, (state, { equipment }) =>
    adapter.upsertOne(equipment, state)
  ),

  on(EquipmentActions.deleteEquipmentSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    EquipmentActions.addEquipmentFailure,
    EquipmentActions.updateEquipmentFailure,
    EquipmentActions.deleteEquipmentFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: EquipmentState | undefined, action: Action) {
  return equipmentReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
